// utils/notificationService.ts
import { Store } from 'react-notifications-component';

type NotificationType = 'default' | 'success' | 'info' | 'warning' | 'danger';
type NotificationPosition = 'bottom-left' | 'bottom-right' | 'bottom-center' | 'top-left' | 'top-right' | 'top-center' | 'center' | 'top-full' | 'bottom-full';

const playSound = (notificationSound: string): HTMLAudioElement => {
    const audio = new Audio(notificationSound);
    audio.loop = true;
    audio.play().catch((err) => {
        console.warn("Autoplay failed. Sound will not play until user interacts:", err);
    });
    return audio;
};

export const notify = (
    title: string,
    message: string,
    type: NotificationType = 'default',
    duration?: number,
    soundUrl?: string,
    position?: NotificationPosition,
    onClick?: () => void,
) => {
    let audio: HTMLAudioElement | null = null;

    if (soundUrl) {
        audio = playSound(soundUrl);
    }

    Store.addNotification({
        title,
        message,
        type,
        insert: 'top',
        container: position || "top-right",
        animationIn: ['animate__animated', 'animate__fadeIn'],
        animationOut: ['animate__animated', 'animate__fadeOut'],
        dismiss: {
            duration: duration || 3000,
            onScreen: true,
        },
        onRemoval: () => {
            if (audio) {
                audio.pause();
                audio.currentTime = 0;
            }
            onClick?.();
        },
    });
};
